import { Group, Stack } from '@mantine/core';
import { Thumbnail } from '../atoms/Thumbnail';
import { Header } from '../atoms/Name';
import { PublishedLink } from '../atoms/PublishLink';
import { View } from '../atoms/View';
import { Iframe } from './Iframe';
import { Qrcode } from './Qrcode';
import { PublishedModel } from '../../interfaces/api';

export function PublishedModelBody({
  model,
  autoActionsGap = false,
  withDelete,
}: {
  model: PublishedModel;
  autoActionsGap?: boolean;
  withDelete?: boolean;
}) {
  return (
    <Group wrap='nowrap' p='xs'>
      <Thumbnail model={model} />
      <Stack gap={0}>
        <Header model={model} withDelete={withDelete} />
        <PublishedLink url={model.url} />
        <Group
          gap={autoActionsGap ? 0 : undefined}
          justify={autoActionsGap ? 'space-between' : undefined}
          wrap='nowrap'
        >
          <View url={model.url} />
          <Iframe url={model.url} />
          <Qrcode url={model.url} name={model.name} />
        </Group>
      </Stack>
    </Group>
  );
}
